import { render, staticRenderFns } from "./PreventiveServicesInformation.vue?vue&type=template&id=143a3bca&"
import script from "./PreventiveServicesInformation.vue?vue&type=script&lang=js&"
export * from "./PreventiveServicesInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports